function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function titleCase(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

// Swatch

function swatchEvent(swatch) {
  swatch.addEventListener("click", (e) => {
    const variantId = e.target.dataset.variantId;
    const productHandle = e.target.dataset.productHandle;
    const productCardWrapper = e.target.closest(".card-wrapper");

    // Remove the active class from all swatches within the same product item
    const allSwatches = productCardWrapper.querySelectorAll(".color-swatch");
    allSwatches.forEach((s) => s?.classList.remove("active"));

    // Add the active class to the clicked swatch
    e.target?.classList.add("active");

    fetch("/products/" + productHandle + ".js")
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        const variant = product.variants?.find(function (variant) {
          return variant.id === parseInt(variantId, 10);
        });

        if (variant && variant.featured_image) {
          const imgLink = productCardWrapper.querySelector(".card__content");
          imgLink.href = `${product.url}?variant=${variant.id}`;
          const informationLink = productCardWrapper.querySelector(
            ".card__information-link"
          );
          informationLink.href = `${product.url}?variant=${variant.id}`;
          const featuredImageContainer = productCardWrapper.querySelector(
            ".card__media .media"
          );
          featuredImageContainer.innerHTML = `<img src="${variant.featured_image.src}" alt="${variant.featured_image.alt}" class="card-media__image">`;
        }

        const parent = e.target.parentNode.parentNode.parentElement;
        const hoverImage = parent.querySelector(".hover--image");
        if (hoverImage && hoverImage.childNodes && hoverImage.childNodes.length > 1) {
          hoverImage.childNodes[1].style.opacity = "0";
        }
      });
  });
}

function initColorSwatchClick() {
  const allSwatches = document.querySelectorAll(".color-swatch");
  allSwatches.forEach((swatch) => swatchEvent(swatch));
}

document.addEventListener("DOMContentLoaded", initColorSwatchClick);

// End Swatch

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling?.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling?.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement?.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement?.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true,
    });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement?.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement?.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle?.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body?.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle?.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details?.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu?.classList.remove("submenu-open");
      });
    document.body?.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    let gorgias = document.querySelector("#chat-button");

    setTimeout(function () {
      if ((gorgias = document.querySelector("#chat-button"))) {
        gorgias.style.visibility = "visible";
        gorgias.style.opacity = "1";
      }
    }, 100);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement?.classList.remove("submenu-open");
    detailsElement?.classList.remove("menu-opening");

    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper")?.classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header?.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle?.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body?.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    let gorgias = document.querySelector("#chat-button");
    setTimeout(function () {
      if (gorgias) {
        gorgias.style.opacity = "0";
        gorgias.style.visibility = "hidden";
      }
    }, 100);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header?.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this?.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body?.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body?.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    const searchIcon = document.querySelector(".search-icon-mobile");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });

    if (!searchIcon) return;
    searchIcon.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(searchIcon);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    this.sliderControlWrapper = this.querySelector(".slider-buttons");

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link?.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1]?.classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.slider.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link?.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1]?.classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton?.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton?.classList.remove(
        "slideshow__autoplay--paused"
      );
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(false, "", false);
    if (document.body?.classList.contains("template-product")) {
      this.updatePickupAvailability();
    }

    changeVariants(this.currentVariant?.id);

    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      setTimeout(() => {
        this.updateImage();
      }, 1000);
      if (document.body?.classList.contains("template-product")) {
       
        this.updateMedia();
        this.updateURL();
        this.updateShareUrl();
      }
      this.renderProductInfo();
      this.updateVariantInput();
    }
  }

  updateImage() {
    let quickBuy = document.querySelector(".quickbuy-container");
    if (quickBuy) {
      let color = this.currentVariant.option1.toLowerCase();
      let swiper = this.parentElement.parentElement.querySelector(".swiper");
      let quickbuyImages = swiper.querySelectorAll(".swiper-slide");
      let paginationBullets = swiper.querySelectorAll(
        ".swiper-pagination-bullet"
      );

      Array.from(quickbuyImages).forEach((element) => {
        const elDataColor = element.dataset.color;
        element.style.display = elDataColor !== color ? "none" : "block";
      });

      let countSameColor = Array.from(quickbuyImages).filter(
        (element) => element.dataset.color === color
      ).length;

      Array.from(paginationBullets).forEach((bullet, index) => {
        bullet.style.display = index < countSameColor ? "inline-block" : "none";
      });
    }
  }

  updateOptions() {
    const radioOptions = Array.from(this.querySelectorAll("fieldset")).map(
      (fieldset) => {
        const checkedRadio = fieldset.querySelector("input:checked");
        return checkedRadio ? checkedRadio.value : null;
      }
    );

    const selectOptions = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );

    this.options = [...radioOptions, ...selectOptions].filter(
      (option) => option !== null
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true,
      this.currentVariant.option1?.toLowerCase()
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(
        new Event("change", {
          bubbles: true,
        })
      );
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateVariantStatuses() {
   
    let selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    // Created this condition to handle cases where some variants were missing the 'option1' attribute.
    // This omission was causing issues where the size was marked as unavailable, despite having stock.
    if (selectedOptionOneVariants.length === 0) {
      selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(":checked").value === variant.options[0]
      );
    }

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      let availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);

      // Created this condition to handle cases where some variants were missing the 'option1' attribute.
      // This omission was causing issues where the size was marked as unavailable, despite having stock.
      if (index === 1 && availableOptionInputsValue.length === 0) {
        availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available && variant.options[0] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
      }

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.parentElement
          .querySelector("label")
          ?.classList.remove("out-of-stockTemp");
          input.parentElement.classList.remove('disabled');
          input.disabled = false
      } else {
        input.parentElement
          .querySelector("label")
          ?.classList.add("out-of-stockTemp");
          input.parentElement.classList.add('disabled');
          input.disabled = true
      }
    });

    
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    if (document.body?.classList.contains("template-product")) {
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const destination = document.getElementById(
            `price-${this.dataset.section}`
          );
          const source = html.getElementById(
            `price-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          );
          if (source && destination) destination.innerHTML = source.innerHTML;

          const price = document.getElementById(
            `price-${this.dataset.section}`
          );

          if (price) price?.classList.remove("visibility-hidden");
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        });
      return;
    }

    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    );
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const bottomBuyBar = document.querySelector(".bottombarButton");
    const bottomBuyBarText = document.querySelector(".bottombarButton > span");

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      bottomBuyBar.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
        bottomBuyBarText.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");
      bottomBuyBar.removeAttribute("disabled");
      bottomBuyBarText.textContent = window.variantStrings.addToCart;
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    // if (price) price?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]')?.textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      )?.value;
    });

    const sliderButtonList = document.querySelectorAll(`.slider-counter__link`);

    const colorLabel = this.querySelector(".form__color-label");
    colorLabel.textContent = `: ${titleCase(this.options[0])}`;
  }
}

customElements.define("variant-radios", VariantRadios);

window.onload = function () {
  const locksmithContent = document.getElementById("locksmith-content");
  const footerNewsletter = document.querySelector(".footer-newsletter");

  if (locksmithContent && footerNewsletter) {
    footerNewsletter.style.display = "none";
  }

  if (locksmithContent) {
    const locksmithForm = document.querySelector(".locksmith-passcode");
    locksmithForm.placeholder = "WACHTWOORD";
  }
};

// Recently Viewed

const templateProduct = document.querySelector(".template-product");
const templateProductTitle = document.querySelector(".product-recently__title");
const recentlyViewedContainer = document.querySelector(
  ".section--recently-viewed"
);
const productId = document.documentElement.getAttribute("data-product-id");

let recentlyViewed = [];

if (Cookies.get("recently_viewed")) {
  recentlyViewed = JSON.parse(Cookies.get("recently_viewed"));
}

if (!recentlyViewed.includes(productId)) {
  recentlyViewed.unshift(productId);

  if (templateProduct) {
    Cookies.set("recently_viewed", JSON.stringify(recentlyViewed.slice(0, 4)), {
      expires: 1,
    });
  }
}

if (
  recentlyViewedContainer &&
  recentlyViewed[0] === null &&
  recentlyViewed.length === 1
) {
  recentlyViewedContainer?.classList.add("hidden");
}

if (recentlyViewedContainer && recentlyViewed.length >= 1) {
  document.querySelector(".recently__title")?.classList.remove("hidden");
}


function transformGraphqlProduct(productNode) {
  if (!productNode) {
    return null;
  }

  const tags = productNode.tags.map((tag) => tag.toLowerCase());
  if (tags.includes("mystery-gift")) {
    return null;
  }

  const variants = productNode.variants.edges.map(({ node }) => {
    return {
      id: parseInt(node.id.replace("gid://shopify/ProductVariant/", "")),
      available: node.availableForSale,
      compare_at_price: node.compareAtPrice?.amount || null,
      options: node.selectedOptions.map((option) => option.value),
      option1: node.selectedOptions[0].value,
      price: node.price?.amount || null,
      title: node.selectedOptions[0].value,
    };
  });

  const options = productNode.options.map((option) => option.name);
  const options_with_values = productNode.options.map((option) => {
    return {
      name: option.name,
      position: productNode.options.indexOf(option) + 1,
      title: option.values,
    };
  });

  const currencySign = window.themeSettings.currencySign;
  let price = productNode.variants.edges[0].node.price.amount.match(/\.\d$/g) ? productNode.variants.edges[0].node.price.amount + '0' : productNode.variants.edges[0].node.price.amount;

  if(price.includes('.00')){
    price = price + ',-'
  }
  let compareAtPrice =
    productNode.variants.edges[0].node.compareAtPrice?.amount;
  let discountPercentage;
  if (compareAtPrice > price) {
    const discountRatio = price / compareAtPrice;
    const discountValue = 1 - discountRatio;
    const numberStr = (discountValue * 100).toFixed(2);
    discountPercentage = numberStr.replace(".00", "");
  }


  let productPrice = Number(price);
  const productCompareAtPrice = Number(compareAtPrice);
  if (productCompareAtPrice != productPrice) {
    productPrice = productPrice.toFixed(2).replace(".", ",");
  }
 
  
  return {
    objectType: "product",
    available: productNode.availableForSale,
    handle: productNode.handle,
    url: `/products/${productNode.handle}`,
    id: parseInt(productNode.id.replace("gid://shopify/Product/", "")),
    tags: productNode.tags.filter(tag => tag.toLowerCase().includes("badge:")).map(tag => tag.toLowerCase().split('badge:')[1].trim()),
    productType: productNode.productType,
    title: productNode.title,
    description: productNode.description,
    variants,
    price: `${
      currencySign === "sign"
        ? "€" + price.replace(".00", "")
        : currencySign === "none" && price.toString().includes(".")
        ? price
        : currencySign === "mark"
        ? price.replace(".00", "").replace(".", ",")
        : price
    }`,
    compare_at_price: `${ Number(compareAtPrice) > Number(price) ? (
      currencySign === "sign"
        ? "€" + compareAtPrice.replace(".0", "")
        : currencySign === "none" && compareAtPrice.toString().includes(".")
        ? compareAtPrice
        : currencySign === "mark"
        ? compareAtPrice.replace(".0", "").replace(".", ",") + ',-'
        : compareAtPrice
      ) : ""
    }`,
    sale_percentage: "-" + discountPercentage + "%",
    featured_image: productNode.featuredImage,
    images: productNode.images.edges.map((image) => image.node.url),
    metafield: productNode.metafield?.value,
    product_status: productNode.metafields[0]?.value,
    has_only_default_variant:
      productNode.options[0].values[0] === "Default Title",
    options,
    vendor: productNode.vendor,
    ...(productNode.options[0] && { option1: productNode.options[0].name }),
    ...(productNode.options[1] && { option2: productNode.options[1].name }),
    ...(productNode.options[2] && { option3: productNode.options[2].name }),
    options_with_values,
    
  };
}

Handlebars.registerHelper("compare", function (a, operator, b, options) {
  var bool = false;

  switch (operator) {
    case "==":
      bool = a == b;
      break;
    case "===":
      bool = a === b;
      break;
    case "!=":
      bool = a != b;
      break;
    case "!==":
      bool = a !== b;
      break;
    case "<":
      bool = a < b;
      break;
    case "<=":
      bool = a <= b;
      break;
    case ">":
      bool = a > b;
      break;
    case ">=":
      bool = a >= b;
      break;
    default:
      throw "Unknown operator " + operator;
  }

  return bool ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper("hasFlag", function (tags, flag, options) {
  if (tags) {
    for (let i = 0; i < tags.length; i++) {
      if (tags[i].startsWith(flag + "|")) {
        const text = tags[i].split("|")[1].replace(/-/g, " ");
        return options.fn({ text });
      }
    }
  }
  return options.inverse(this);
});

Handlebars.registerHelper("contains", function (array, value, options) {
  if (array && array.includes(value)) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

Handlebars.registerHelper("contains", function (str, substring) {
  return str.includes(substring);
});

// Fetch Storefront Products using Handlebars JS

async function fetchStorefrontProducts({ query, productIds }) {
  const PRODUCT_QUERY = `
  availableForSale
  id
  title
  description(truncateAt: 80)
  handle
  tags
  productType
  options {
    name,
    values
  }
  featuredImage {
    src
    height
    width
  }
  images(first: 20) {
    edges {
      node {
        altText
        url
      }
    }
  }
  priceRange {
    maxVariantPrice {
      amount
    }
    minVariantPrice {
      amount
    }
  }
  variants(first: 250) {
    edges {
      node {
        id
        availableForSale
        compareAtPrice {
          amount
        }
        price {
          amount
        }
        title
        selectedOptions {
          value
          name
        }
      }
    }
  }
  vendor
  metafield(key: "location", namespace: "information") {
    value
  },
   metafields(identifiers: {key: "product_status", namespace: "custom"}) {
        value
  }
`;

  let graphQuery = query;

  if (!graphQuery) {
    const graphqlIds = productIds
      .filter((x) => x !== productId)
      .map((id) => `"${btoa(`gid://shopify/Product/${id}`)}"`);
    graphQuery = `query allProducts @inContext(country: ${Shopify.country}) {
      nodes(ids: [${graphqlIds}]) {
        id
        ... on Product {
          ${PRODUCT_QUERY}
        }
        ... on ProductOption {
          id
          name
          values
        }
      }
    }`;
  }

  const requestOptions = {
    method: "POST",
    headers,
    body: graphQuery,
  };

  const productContainer = document.querySelector(".product-recently");

  return fetch(
    `https://${Shopify.shop}/api/2023-04/graphql.json`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(({ data }) => {
      let products = data.nodes
        .filter((node) => node)
        .map((product) => transformGraphqlProduct(product));

      products = products.filter((x) => x !== null);
      if (products.length > 0 && productContainer) {
        recentlyViewedContainer?.classList?.remove("hidden");
        const templateSource =
          document.querySelector("#product-template").innerHTML;
        const template = Handlebars.compile(templateSource);
        const productList = template({ products });

        productContainer.innerHTML = productList;
      } else {
        recentlyViewedContainer?.classList?.add("hidden");
      }
    })
    .catch((error) => {
      console.error("Error in fetching storefront products", error);
    });
}

fetchStorefrontProducts({ productIds: recentlyViewed });

document.addEventListener("DOMContentLoaded", () => {
  const openPopIn = (id) => {
    if (window.innerWidth <= 780) {
      gsap.to(`.side_pop_in_${id}`, {
        duration: 0.25,
        y: "0%",
        x: "0%",
        ease: Power4,
      });
    } else {
      gsap.to(`.side_pop_in_${id}`, {
        duration: 0.25,
        x: "0%",
        y: "0%",
        ease: Power4,
      });
    }
    gsap.to(`.${id}`, { duration: 0, display: "flex" });
    gsap.to(`.outside_sidebar_${id}`, {
      duration: 0.25,
      opacity: 0.4,
      ease: Power4,
    });
    gsap.to("body", { duration: 0, overflow: "hidden", delay: 1 });

    document.body?.classList.add("quickbuy-open");
  };

  const closePopIn = (id) => {
    if (window.innerWidth <= 780) {
      gsap.to(`.side_pop_in_${id}`, {
        duration: 0.25,
        y: "100%",
        x: "0%",
        ease: Power4,
      });
    } else {
      gsap.to(`.side_pop_in_${id}`, {
        duration: 0.25,
        x: "100%",
        y: "0%",
        ease: Power4,
      });
    }
    gsap.to(`.outside_sidebar_${id}`, {
      duration: 0.25,
      opacity: 0,
      ease: Power4,
    });
    gsap.to(`.${id}`, { duration: 0, display: "none", delay: 1 });
    gsap.to("body", { duration: 0, overflow: "auto" });

    document.body?.classList.remove("quickbuy-open");
  };

  document.body.addEventListener("click", (event) => {
    let quickBuyElement = event.target.closest("[data-quickbuy-id]");
    if (!quickBuyElement) return;

    const variantRadiosElement = document.querySelector("variant-radios");
    if (variantRadiosElement) {
      variantRadiosElement.updateOptions();
      variantRadiosElement.updateMasterId();
      setTimeout(() => {
        variantRadiosElement.updateImage();
      }, 1000);
    }

    let id = quickBuyElement.getAttribute("data-quickbuy-id");
    openPopIn(id);
  });

  document.body.addEventListener("click", (event) => {
    if (
      event.target?.classList.contains("drawer__close") ||
      event.target?.classList.contains("outside_sidebar")
    ) {
      let id = event.target.getAttribute("data-quickbuy-close-id");
      closePopIn(id);
    }
  });

  document.body.addEventListener("click", (event) => {
    let productFormButton = event.target.closest(".product-form__buttons");

    if (productFormButton) {
      let parentPopIn = event.target.closest(".side_pop_in");
  
      if (parentPopIn) {
        let id = parentPopIn
          .querySelector(".drawer__close")
          .getAttribute("data-quickbuy-close-id");
        setTimeout(() => {
          if (id) closePopIn(id);
        }, 1000);
      }
    }
  });
});

function sortProductSizes() {
  const sizeMappingOrder = {
    XS: 1,
    "XS/S": 2,
    S: 3,
    "S/M": 4,
    M: 5,
    "M/L": 6,
    ML: 7,
    L: 8,
    "L/XL": 9,
    XL: 10,
    XXL: 11,
    XXS: 12,
    XXXL: 13,
    "4XL": 14,
    VERVL: 15,
    "€50": 16,
    "€75": 17,
    "€100": 18,
    "€150": 19,
    "€200": 20,
    "€250": 21,
  };

  function compareSizes(sizeElementFirst, sizeElementSecond) {
    const sizeFirst = sizeElementFirst.textContent.trim();
    const sizeSecond = sizeElementSecond.textContent.trim();

    const rankingFirst = sizeMappingOrder[sizeFirst];
    const rankingSecond = sizeMappingOrder[sizeSecond];

    if (rankingFirst && rankingSecond) {
      return rankingFirst - rankingSecond;
    }
    if (rankingFirst) return -1;
    if (rankingSecond) return 1;

    const parsedFirst =
      parseFloat(sizeFirst.replace(",", ".")) || sizeFirst.toUpperCase();
    const parsedSecond =
      parseFloat(sizeSecond.replace(",", ".")) || sizeSecond.toUpperCase();

    if (typeof parsedFirst === "number" && typeof parsedSecond === "number") {
      return parsedFirst - parsedSecond;
    }
    return parsedFirst.localeCompare(parsedSecond);
  }

  function arrangeSizesForPLP(container) {
    const sizeElements = Array.from(
      container.querySelectorAll(".quickbuy-size > a")
    );
    const sortedSizes = sizeElements.sort(compareSizes);
    sortedSizes.forEach((sizeElement) =>
      container.appendChild(sizeElement.parentElement)
    );
  }

  function arrangeSizesForPDP(container) {
    const sizeElements = Array.from(
      container.querySelectorAll(".color-label_wrapper.degree")
    );
    const sortedElements = sizeElements.sort((elementFirst, elementSecond) =>
      compareSizes(
        elementFirst.querySelector("label"),
        elementSecond.querySelector("label")
      )
    );
    sortedElements.forEach((el) => container.appendChild(el));
  }

  const plpContainers = document.querySelectorAll(".quickbuy-options-wrapper");
  plpContainers.forEach(arrangeSizesForPLP);

  const pdpContainers = document.querySelectorAll(
    ".size-variant-picker-container"
  );
  pdpContainers.forEach(arrangeSizesForPDP);
}

document.addEventListener("DOMContentLoaded", sortProductSizes);
